"use strict";

angular.module("exploitation")

	.controller("SummaryCtrl", [
		"$scope", "$route", "periods", "linesCount", "stopAreasCount", "vehicleJourneysCount", "networks", "summaryLines",
	function ($scope, $route, periods, linesCount, stopAreasCount, vehicleJourneysCount, networks, summaryLines) {

		$scope.data = {
			periods: periods.data,
			linesCount: linesCount.data,
			stopAreasCount: stopAreasCount.data,
			vehicleJourneysCount: vehicleJourneysCount.data,
			networks: networks.data,
			summaryLines: summaryLines.data
		};

		$scope.isSimulation = function () {
			const ref = sessionStorage.getItem("referential");
			if (ref != null) {
				return ref.startsWith("simulation_");
			} else {
				return false;
			}
		}

		$scope.getProductionPeriodsFormatted = function () {
			$scope.data.periods = $scope.data.periods.filter(period => period > 0);

			if($scope.data.periods) {
				const minMillis = Math.min(...$scope.data.periods);
				const maxMillis = Math.max(...$scope.data.periods);

				if(minMillis === 0 && maxMillis === 0){
					return "Pas de données";
				}

				const minDate = new Date(minMillis);
				const maxDate = new Date(maxMillis);

				let dateNowWithoutTime = new Date(Date.now());
				dateNowWithoutTime.setHours(0);
				dateNowWithoutTime.setMinutes(0);
				dateNowWithoutTime.setSeconds(0);
				dateNowWithoutTime.setMilliseconds(0);


				if(maxDate.getTime() < dateNowWithoutTime.getTime()){
					return "<p><i class=\"fa fa-exclamation-triangle fa-red\"></i> Données expirées</p>" + minDate.toLocaleDateString("fr-FR") + " au " + maxDate.toLocaleDateString("fr-FR");
				}
				return minDate.toLocaleDateString("fr-FR") + " au " + maxDate.toLocaleDateString("fr-FR");
			}
		};

	}]);